import { useEffect, useState } from "react";
import { useGetService } from "./useGetService";
import { API, DashboardTabs } from "../constants";

// Third party
// import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import { getUserData } from "../shared/utils";
import { ITmResponse } from "../types/global.types";
import { useArrivalDepartureData } from "./useArrivalDepartureData";
import moment from "moment";

export const useHotelVendorDasboard = (
  startDate: Date,
  endDate: Date,
  selectedTab: string,
  appliedStartDate: Date,
  appliedEndDate: Date
) => {
  const [rows, setRows] = useState([]);
  const [isRowsLoading, setRowsLoading] = useState(false);
  const vendorId = getUserData()["cognito:username"];

  // API CALL

  // FETCH SHIPBOARD HR REQUEST DETAILS
  const { response: shipboardAssigned, isLoading: isShipboardAssignedLoading } =
    useGetService(`${API.VENDOR_SERVICE_REQUEST.SHIPBOARD_HR_ARRIVED}s`);

  const { response, isLoading, handleSearchApply, error, detailedError } =
    useArrivalDepartureData({
      startDate,
      endDate,
      selectedTab,
    });

  // FETCH CREATED MANUAL REQUEST DETAILS
  const {
    response: manualRequestDetails,
    isLoading: ismanualRequestDetailsLoading,
  } = useGetService(
    `${API.VENDOR_SERVICE_REQUEST.CREATE_MANUAL_REQUEST}s?vendorId=${vendorId}`
  );

  console.log("manualRequestDetails", manualRequestDetails);

  const assignmentStartDate = moment(appliedStartDate); //.subtract(7, "day");
  const assignmentEndDate = moment(appliedEndDate);

  const hotelServiceRequestEndDate = moment(appliedEndDate).add(2, "day");
  // FETCH TRANSPORT ASSIGNMENT
  const {
    response: serviceRequests,
    isLoading: isAssignedDataLoading,
    refetch: refetchAssinged,
  } = useGetService(
    `${API.CARNIVAL_ADMIN.GET_SERVICE_REQUEST_BY_VENDOR_ID
    }?vendorId=${vendorId}&startDate=${assignmentStartDate.format(
      "DD/MM/YYYY"
    )}&endDate=${assignmentEndDate.format("DD/MM/YYYY")}`
  );

  // FETCH HOTEL ASSIGNMENT
  const {
    response: hotelServiceRequests,
    isLoading: ishotelServiceLoading,
    refetch: refetchHotelServiceRequest,
  } = useGetService(
    `${API.HOTEL.GET_HOTEL_SERVICE_REQUEST_BY_VENDOR_ID
    }?vendorId=${vendorId}&startDate=${assignmentStartDate.format(
      "DD/MM/YYYY"
    )}&endDate=${hotelServiceRequestEndDate.format("DD/MM/YYYY")}`
  );

  useEffect(() => {
    setRowsLoading(isLoading || isAssignedDataLoading);
    if (isLoading === false && response && response.data.length > 0) {
      setRows(dataHandling(response.data));
    } else {
      setRows([]);
    }
  }, [
    response,
    isLoading,
    serviceRequests,
    isAssignedDataLoading,
    isShipboardAssignedLoading,
    shipboardAssigned,
    ismanualRequestDetailsLoading,
    manualRequestDetails,
    selectedTab,
    hotelServiceRequests,
    ishotelServiceLoading,
  ]);

  console.log("hotelServiceRequests", hotelServiceRequests);

  const dataHandling = (resData: ITmResponse[]) => {
    let newData: any = [];
    const data = _.cloneDeep(resData);
    data.forEach((x) => {
      const y = {
        ...x,
        id: x.EmpId, //uuidv4(),
        isManualRequestCreated:
          (!ismanualRequestDetailsLoading &&
            manualRequestDetails?.data &&
            manualRequestDetails?.data.some((v: any) => v.tmId === x.EmpId)) ||
          false,
        assignedInfo:
          !isAssignedDataLoading &&
          serviceRequests?.data &&
          serviceRequests?.data.find((v: any) => v.tmId === x.EmpId),
        isHotelScanned:
          !ishotelServiceLoading &&
          hotelServiceRequests &&
          hotelServiceRequests?.filter((v: any) => v.tmId === x.EmpId),
      };

      // This code is temp once real data will come then need to remove the code
      const isShipboardScanned =
        !isShipboardAssignedLoading &&
        shipboardAssigned?.data &&
        shipboardAssigned?.data.every((v: any) => v.tmId !== x.EmpId);

      isShipboardScanned && newData.push(y);
    });

    let finalData = [];
    if (selectedTab === DashboardTabs.ARRIVALS) {
      finalData = newData.filter(
        (x: any) => x.isManualRequestCreated === false
      );
      setRowsLoading(false);
      return finalData;
    }

    setRowsLoading(false);
    return newData;
  };

  return {
    rows,
    isRowsLoading,
    handleSearchApply,
    error,
    detailedError
  };
};
